// ✅ Add Selectors
export const selectAddManagementData = (state) => state?.managements?.addManagement?.data;
export const selectAddManagementLoading = (state) => state?.managements?.addManagement?.loading;
export const selectAddManagementError = (state) => state?.managements?.addManagement?.error;

// ✅ Update Selectors
export const selectUpdateManagementData = (state) => state?.managements?.updateManagement?.data;
export const selectUpdateManagementLoading = (state) => state?.managements?.updateManagement?.loading;
export const selectUpdateManagementError = (state) => state?.managements?.updateManagement?.error;

// ✅ Delete Selectors
export const selectDeleteManagementData = (state) => state?.managements?.deleteManagement?.data;
export const selectDeleteManagementLoading = (state) => state?.managements?.deleteManagement?.loading;
export const selectDeleteManagementError = (state) => state?.managements?.deleteManagement?.error;

// ✅ Resend HR Invite Selectors
export const selectResendHrInviteData = (state) => state?.managements?.resendHrInvite?.data;
export const selectResendHrInviteLoading = (state) => state?.managements?.resendHrInvite?.loading;
export const selectResendHrInviteError = (state) => state?.managements?.resendHrInvite?.error;

// ✅ List Selectors (with pagination)
export const selectManagementsList = (state) => state?.managements?.getManagementsList?.data || [];
export const selectManagementsListLoading = (state) => state?.managements?.getManagementsList?.loading;
export const selectManagementsListError = (state) => state?.managements?.getManagementsList?.error;
export const selectManagementsListTotal = (state) => state?.managements?.getManagementsList?.total || 0;

// ✅ Get All Managements Selectors (without pagination)
export const selectManagements = (state) => state?.managements?.getManagements?.data || [];
export const selectManagementsLoading = (state) => state?.managements?.getManagements?.loading;
export const selectManagementsError = (state) => state?.managements?.getManagements?.error;
export const selectManagementsTotal = (state) => state?.managements?.getManagements?.total || 0;

// ✅ Detail Selectors
export const selectManagementDetail = (state) => state?.managements?.getManagementDetail?.data;
export const selectManagementDetailLoading = (state) => state?.managements?.getManagementDetail?.loading;
export const selectManagementDetailError = (state) => state?.managements?.getManagementDetail?.error;

// ✅ Import CSV Selectors
export const selectImportManagementsCsvData = (state) => state?.managements?.importManagementsCsv?.data;
export const selectImportManagementsCsvLoading = (state) => state?.managements?.importManagementsCsv?.loading;
export const selectImportManagementsCsvError = (state) => state?.managements?.importManagementsCsv?.error;

// ✅ Overall State Selector
export const selectManagementsState = (state) => state?.managements;